module.exports = __webpack_public_path__ + "static/img/c4-1.3fd626b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/c4-1.png
// module id = 719
// module chunks = 1